/* eslint-disable @typescript-eslint/no-explicit-any */
import { Canvas, Object as FabricObject, Group } from 'fabric';

/**
 * Проверяет наличие текстовых объектов в массиве объектов
 * @param objects - Массив объектов для проверки
 * @returns true если есть текстовые объекты, false если нет
 */
export const isHaveTextObject = (objects: FabricObject[] | null) => {
  if (!objects) return false;
  return objects.some(
    (obj) => obj.type.toLowerCase() === 'textbox' || obj.type.toLowerCase() === 'textentity',
  );
};

/**
 * Отключает масштабирование для групп содержащих текстовые объекты
 * Текст нельзя растягивать, поэтому для групп с текстом отключаем контролы масштабирования
 * @param canvas - Canvas для обработки
 */
export const disableScalingForTextboxInGroup = (canvas: Canvas | null) => {
  if (!canvas) return;
  const activeObjects = canvas.getActiveObjects();
  const activeGroupSelection = canvas.getActiveObject();

  let hasTextObject = false;
  if (activeObjects)
    hasTextObject = activeObjects.some((obj: any) => {
      if (obj.type.toLowerCase() === 'textbox' || obj.type.toLowerCase() === 'textentity') {
        return true;
      } else if (obj.type.toLowerCase() === 'group' && obj instanceof Group) {
        return obj
          .getObjects()
          .some((o) => o.type.toLowerCase() === 'textbox' || o.type.toLowerCase() === 'textentity');
      }
      return false;
    });
  if (activeObjects.length > 1) {
    if (hasTextObject) {
      activeGroupSelection?.set({
        lockScalingX: true,
        lockScalingY: true,
      });
      activeGroupSelection?.setControlsVisibility({
        tl: false, // Top left corner
        tr: false, // Top right corner
        bl: false, // Bottom left corner
        br: false, // Bottom right corner
        ml: false, // Middle left
        mt: false, // Middle top
        mr: false, // Middle right
        mb: false, // Middle bottom
        mtr: false, // Rotation control
      });
    }
  } else if (activeObjects.length === 1 && hasTextObject) {
    activeGroupSelection?.setControlsVisibility({
      tl: false, // Top left corner
      tr: false, // Top right corner
      bl: false, // Bottom left corner
      br: false, // Bottom right corner
      ml: true, // Middle left
      mt: false, // Middle top
      mr: true, // Middle right
      mb: false, // Middle bottom
      mtr: false, // Rotation control
    });
  }
};
